export class UnLockRequest {
     typeId: number;
     startDate: string;
     endDate: string;
    
}


// WEBPACK FOOTER //
// ./src/app/customerservice/models/unLock-Request.ts